import axios from 'axios'
import React, { useContext, useEffect, useReducer } from 'react'
import reducer from '../reducers/produtos_reducer'
import { produtos_url as url } from '../utils/constants'
import {
  SIDEBAR_OPEN,
  SIDEBAR_CLOSE,
  GET_PRODUTOS_BEGIN,
  GET_PRODUTOS_SUCCESS,
  GET_PRODUTOS_ERROR,
  GET_SINGLE_PRODUTOS_BEGIN,
  GET_SINGLE_PRODUTOS_SUCCESS,
  GET_SINGLE_PRODUTOS_ERROR,
} from '../actions'

const initialState = {
  isSidebarOpen: false,
  produtos_loading: false,
  produtos_error: false,
  produtos: [],
  featured_produtos: [],
  single_produtos_loading: false,
  single_produtos_error: false,
  single_produtos: {},
}

const ProdutosContext = React.createContext()

export const ProdutosProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState)

  const openSidebar = () => {
    dispatch({ type: SIDEBAR_OPEN })
  }
  const closeSidebar = () => {
    dispatch({ type: SIDEBAR_CLOSE })
  }

  const fetchProdutos = async (url) => {
    dispatch({ type: GET_PRODUTOS_BEGIN })
    try {
      const response = await axios.get(url)
      const produtos = response.data
      dispatch({ type: GET_PRODUTOS_SUCCESS, payload: produtos })
    } catch (error) {
      dispatch({ type: GET_PRODUTOS_ERROR })
    }
  }

  const fetchSingleProdutos = async (url) => {
    dispatch({ type: GET_SINGLE_PRODUTOS_BEGIN })
    try {
      const response = await axios.get(url)
      const singleProdutos = response.data
      dispatch({ type: GET_SINGLE_PRODUTOS_SUCCESS, payload: singleProdutos })
    } catch (error) {
      dispatch({ type: GET_SINGLE_PRODUTOS_ERROR })
    }
  }

  useEffect(() => {
    fetchProdutos(url)
  }, [])

  return (
    <ProdutosContext.Provider
      value={{ ...state, openSidebar, closeSidebar, fetchSingleProdutos }}
    >
      {children}
    </ProdutosContext.Provider>
  )
}
// make sure use
export const useProdutosContext = () => {
  return useContext(ProdutosContext)
}
